import React, { useContext, useState } from "react";
import Context from "../../../../Context";
import List from "../../../Misc/List";
import Filters from "../../../Misc/Filters";
import Sortings from "../../../Misc/Sortings";
import FieldsList from "../../../Misc/FieldsList";

function EventLog() {
  const cx = useContext(Context);

  let search = [];
  let sort = [];

  let savedFields = localStorage.getItem("eventLogFields")
    ? JSON.parse(localStorage.getItem("eventLogFields"))
    : false;
  let fields = savedFields || [];

  const [currentSearchJSON, changeCurrentSearch] = useState(
    JSON.stringify(search || [])
  );

  const [currentSortingsJSON, changeCurrentSortings] = useState(
    JSON.stringify(sort || [])
  );

  const [currentFieldsJSON, changeCurrentFields] = useState(
    JSON.stringify(fields || [])
  );

  const [showfilters, toggleFilters] = useState(false);

  function fieldsChange(fields) {
    localStorage.setItem("eventLogFields", JSON.stringify(fields));
    changeCurrentFields(JSON.stringify(fields));
  }

  function filtersChange(search) {
    changeCurrentSearch(JSON.stringify(search));
  }

  function sortingsChange(sortings) {
    changeCurrentSortings(JSON.stringify(sortings));
  }

  let flt = [
    {
      id: "datetime",
      title: cx.t("admin.eventLog.filter_datetime"),
      kind: "range",
      active: false,
      value: [],
    },
    {
      id: "type",
      title: cx.t("admin.eventLog.filter_type"),
      active: false,
      activeVariants: [],
      multiple: true,
      kind: "dropdown",
      variants: [
        ["Сообщение", [{ field: "type", compare: "EQL", value: "M" }]],
        ["Предупреждение", [{ field: "type", compare: "EQL", value: "W" }]],
        ["Ошибка", [{ field: "type", compare: "EQL", value: "E" }]],
      ],
    },
  ];

  let srt = [
    {
      id: "byCreatedASC",
      active: false,
      title: cx.t("admin.eventLog.sort_byCreatedASC"),
      value: ["datetime ASC"],
    },
    {
      id: "byCreatedDESC",
      active: false,
      title: cx.t("admin.eventLog.sort_byCreatedDESC"),
      value: ["datetime DESC"],
    },
  ];

  let flds = [
    "id",
    "type",
    "typename",
    "datetime",
    "username",
    "session",
    "code",
    "text",
    "object",
  ];

  let filters = (
    <div
      className={`${
        showfilters ? "d-flex" : "d-none"
      }  align-items-center justify-content-end mt-0 py-5 px-7 mb-2 border-bottom w-100 shadow-sm`}
    >
      <Filters changeFn={filtersChange} filters={flt} />
    </div>
  );
  return (
    <>
      <div className="card card-custom gutter-b ">
        <div className="card-header">
          <div className="card-title w-100 mr-0 d-flex align-items-center justify-content-between">
            <h3 className="card-label">{cx.t("admin.eventLog.title")}</h3>
            <div>
              <FieldsList
                changeFn={fieldsChange}
                fields={flds}
                activeFields={fields}
              />
              <button
                className="btn btn-light mr-2"
                onClick={() => toggleFilters(!showfilters)}
              >
                <i
                  className={`fa fa-filter p-0 ${
                    showfilters ? "text-primary" : "text-muted"
                  }`}
                ></i>
              </button>
              <Sortings changeFn={sortingsChange} sortings={srt} />
            </div>
          </div>
        </div>
        {filters}
        <div className="card-body">
          <List
            listKey="EventLogList"
            search={currentSearchJSON}
            sort={currentSortingsJSON}
            fields={currentFieldsJSON}
            limit={20}
            keyField="id"
            path="/admin/event/log/list"
            table
          >
            <EventLogEntry />
          </List>
        </div>
      </div>
    </>
  );
}

function EventLogEntry(props) {
  const cx = useContext(Context);
  let values = [];
  for (let field in props) values.push(field);
  function explain(json) {
    cx.say(json);
  }
  let trClasses = "";
  if (props.type === "E") trClasses = "text-danger";
  if (props.type === "W") trClasses = "text-warning";
  return (
    <tr className={trClasses}>
      {values.map((v) => {
        let value = props[v];
        let date = new Date(value);

        if (typeof value === "object") {
          let json = JSON.stringify(value);
          if (json === "null") {
            value = "-";
          } else {
            value = (
              <span
                className="text-muted text-hover-primary btn"
                onClick={() => explain(json)}
              >
                {json.length > 20 ? json.substring(0, 20) + "..." : json}
              </span>
            );
          }
        }
        if (date.getFullYear() > 1971) {
          value = date.toLocaleString();
        }
        return (
          <td key={v} className="text-nowrap">
            {value}
          </td>
        );
      })}
    </tr>
  );
}

export default EventLog;
